import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-select",
  templateUrl: "./field-set-select.component.html",
  styles: [],
  providers: [],
})
export class FieldSetSelectComponent {

  @Input() public fieldOptions: any;
  @Input() public guideSelections: string [];
  @Output() public dataChanged = new EventEmitter();
  public newSelection: string;
  public newKey: string;

    public dropped(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
    }

  public addSelection(key, value) {
    if (!this.fieldOptions.useCustomKey) {
      this.fieldOptions.data.values.push({value: Math.random().toString(36).substr(2, 12), label: value});
    } else {
      this.fieldOptions.data.values.push({value: key, label: value});
    }
    this.addGuideSelection(value);
  }

  public addGuideSelection(value: string) {
    if (value) {
      const exists = this.guideSelections.find((sel) => sel === value);
      if (!exists) {
        this.guideSelections.push(value);
      }
    }
  }

  public deleteSelection(isConfirmed, index: number, selection: string) {
    if (isConfirmed) {
      this.fieldOptions.data.values.splice(index, 1);
      this.deleteGuideSelection(selection);
    }
  }

  public deleteGuideSelection(selection: string) {
    if (selection) {
      for (let i = 0; i < this.guideSelections.length; i++) {
        if (this.guideSelections[i] === selection) {
          this.guideSelections.splice(i, 1);
          break;
        }
      }
    }
  }

  public clearForm(form) {
    form.reset();
  }

  public dataChangedEvent() {
    this.dataChanged.emit();
  }

  public saveSelectValues(value) {
    this.fieldOptions.useCustomKey = value;
    this.dataChanged.emit();
  }
}
